import React from 'react';
import { apiFetch as fetch } from '../../common/Helpers';
import { Helmet } from 'react-helmet';
import TagValidationComponent from '../../components/TagValidationComponent';

class ValidationsNewPage extends React.Component {

    render() {

        return (
            <div>
                <Helmet>
                    <title>Tag Genie - Create Validation</title>
                </Helmet>
                <TagValidationComponent onSave={this.handleSave} />
            </div>
        );
    }

    handleSave = async (tagValidation) => {

        fetch(`api/validations`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(tagValidation)
        }).then(() => {
            this.props.history.push("/validations");
        });
    }
}

export default ValidationsNewPage;